import React from 'react';

export const TooltipTableCell = ({
    label,
    tooltipText,
    emptyText = '-',
    arrHeadersPath = '',
    showClass = false,
}) => {
    if (tooltipText) {
        /**If the tooltip value contains "\n", it will be taken as a array and will separated with line breack*/
        let lineBreak = [];
        if (tooltipText.length > 0) {
            lineBreak = tooltipText.split(
                '\n',
                tooltipText.split('\n').length - 1
            );

            tooltipText = lineBreak.length > 0 ? lineBreak : tooltipText;
        }
        return (
            <div className="tooltipCss finamiga-color">
                {label ? label : emptyText}
                <span className="tooltiptext btn btn-outline-primary">
                    {arrHeadersPath && <b>{arrHeadersPath}</b>}
                    {lineBreak.length > 0
                        ? tooltipText.map((item, index) => {
                              return (
                                  <div key={index}>
                                      {item}
                                      <br></br>
                                  </div>
                              );
                          })
                        : tooltipText
                        ? tooltipText
                        : '-'}
                </span>
            </div>
        );
    } else {
        return (
            <div className={`${showClass && 'finamiga-color'}`}>
                {label ? label : emptyText}
            </div>
        );
    }
};
